import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProgramHomeComponent } from './program-home.component';
import {ProgramService} from '../../../services/vpp/program.service';
import {NgbActiveModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ProgramIndexComponent} from './program-index/program-index.component';
import {ProgramDispatchesIndexComponent} from './program-dispatches/program-dispatches-index.component';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {ProgramEditModalComponent} from '../program-edit-modal/program-edit-modal.component';
import {MatTabsModule} from "@angular/material/tabs";
import {MatTableModule} from "@angular/material/table";
import {MatPaginatorModule} from "@angular/material/paginator";
import {CalibrantLoadModule} from "../../shared/calibrant-load/calibrant-load.module";
import {MatSortModule} from "@angular/material/sort";
import {MatIconModule} from "@angular/material/icon";
import {MatDialogModule} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatTooltipModule} from "@angular/material/tooltip";
import { MatButton } from '@angular/material/button';
import { MatRipple } from '@angular/material/core';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    FormsModule,
    MatTabsModule,
    MatTableModule,
    MatPaginatorModule,
    CalibrantLoadModule,
    MatSortModule,
    MatIconModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatButton,
    MatRipple,
  ],
    declarations: [
        ProgramHomeComponent,
        ProgramIndexComponent,
        ProgramDispatchesIndexComponent,
        ProgramEditModalComponent
    ],
    exports: [
        ProgramHomeComponent
    ],
    providers: [
        ProgramService,
        NgbActiveModal,
    ]
})
export class ProgramHomeModule { }
